export default "__VITE_ASSET__sFg2jAQU__"